import {ZENDESK_LOAD_DELAY_MS, ZENDESK_SCRIPT_URL, ZENDESK_SNIPPET_ID} from "@montana/constants/zendesk";
import {debug} from "@montana/services/logger";
import {loadScriptAsync} from "@montana/services/script-injection";
import {delayPromise} from "./promise.helper";

declare global {
    interface Window {
        zE: IZendeskWidget | undefined;
        zESettings: IZendeskSettings | undefined;
    }
}

interface IZendeskWidget {
    (
        type: "webWidget",
        command: "updateSettings",
        payload: IWebWidgetSettings
    ): void;
}

interface IZendeskSettings {
    webWidget?: IWebWidgetSettings;
}

interface IWebWidgetSettings {
    chat?: {
        suppress?: boolean;
        departments?: IWebWidgetDepartments;
    };
}

interface IWebWidgetDepartments {
    enabled?: string[];
}

let scriptReady: Promise<boolean> | undefined = undefined;

function setSuppression(suppress: boolean) {
    if (!window) return;

    debug(`Setting Zendesk suppression: ${suppress}`);
    const {zE, zESettings} = window;

    // If zE is initialized, update the runtime settings.
    if (zE) {
        zE("webWidget", "updateSettings", {
            chat: {
                suppress, departments: {
                    enabled: []
                }
            }
        });
    }

    // If zE is NOT initialized, set or update the initial settings variable.
    else {
        window.zESettings = {
            ...zESettings,
            webWidget: {
                ...zESettings?.webWidget,
                chat: {
                    ...zESettings?.webWidget?.chat,
                    suppress,
                    departments: {
                        enabled: []
                    }
                }
            }
        };
    }
}

/**
 * Removes suppression of the Zendesk widgets. Will attempt to load the Zendesk widgets
 * script if it does not exist.
 */
export function showZendeskChat(loadScript: boolean) {
    if (loadScript && !scriptReady) {
        scriptReady = delayPromise(ZENDESK_LOAD_DELAY_MS)
            .then(() => loadScriptAsync(ZENDESK_SCRIPT_URL, {
                attributes: {
                    id: ZENDESK_SNIPPET_ID,
                }
            }));
    }

    setSuppression(false);
}

/**
 * Sets suppression of the Zendesk widgets.
 */
export function hideZendeskChat() {
    setSuppression(true);
}
